import { TreeNavigatorLogic } from '../../../../tree/navigation/TreeNavigatorLogic';
import { ITranslationKey } from '../../../translations/ITranslationKey';
import { Widget, WidgetOrRoot } from '../../Widget';
import { WidgetRepository } from '../WidgetRepository';
import { isRoot } from '../containers/root';

/**
 * Data la radice di un albero di widget, restituisce un array di chiavi di traduzione
 * dell'intero albero.
 */
export function getTreeTranslationKeys(root: WidgetOrRoot): ITranslationKey[] {
  const result: ITranslationKey[] = [];
  TreeNavigatorLogic.forEachNode(root, node => {
    if (isRoot(node)) return;
    const widgetKeys = getTranslationKeys(node);
    result.push(...widgetKeys);
  });

  return result;
}

/**
 * Ritorna le chiavi di traduzione del widget
 */
export function getTranslationKeys(widget: Widget): ITranslationKey[] {
  return (
    WidgetRepository.find(widget.type)?.translationSchema?.extract(widget) ?? []
  );
}
